export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const MIN_RESOLUTION = 500;

export const DROPZONE_CONFIG = {
  accept: {
    'image/jpeg': [],
  },
  maxFiles: 1,
  maxSize: MAX_FILE_SIZE,
  noClick: true,
};
